/** Resolve which email to use when completing a Firebase email sign-in link. */

export function emailFromSignInLinkUrl(linkUrl: string): string {
  try {
    const u = new URL(linkUrl);
    const direct = (u.searchParams.get('email') || '').trim();
    if (direct.includes('@')) return direct;
    const cont = (u.searchParams.get('continueUrl') || '').trim();
    if (cont) {
      const cu = new URL(cont);
      const nested = (cu.searchParams.get('email') || '').trim();
      if (nested.includes('@')) return nested;
    }
  } catch {
    /* ignore */
  }
  return '';
}

/**
 * Prefer continue-URL / invite ?email= over localStorage.
 * Stale emailForSignIn from a prior magic-link request causes auth/invalid-email on invites.
 */
export function resolveEmailForEmailLinkSignIn(opts: {
  linkUrl: string;
  emailHint?: string | null;
  storedEmail?: string | null;
}): string {
  const hint = (opts.emailHint || '').trim();
  if (hint.includes('@')) return hint;
  const fromUrl = emailFromSignInLinkUrl(opts.linkUrl);
  if (fromUrl) return fromUrl;
  const stored = (opts.storedEmail || '').trim();
  if (stored.includes('@')) return stored;
  return '';
}

export function isEmailLinkEmailMismatch(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const code = 'code' in err ? String((err as { code?: string }).code) : '';
  const msg = err instanceof Error ? err.message : String(err);
  return (
    code === 'auth/invalid-email' ||
    /does not match the sign-in email/i.test(msg)
  );
}
